import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { CgWebsite } from "react-icons/cg";
import { BsGithub } from "react-icons/bs";

function ProjectCards(props) {
  const hasImage = Boolean(props.imgPath);
  const hasGithub = Boolean(props.ghLink);
  const hasDemo = Boolean(props.demoLink);
  const imgFit = props.imgFit || "cover";
  const primaryLabel = props.ghLabel || (props.isBlog ? "Blog" : "GitHub");
  const demoLabel = props.demoLabel || "Demo";

  return (
    <Card className="project-card-view h-100">
      {hasImage && (
        <Card.Img
          variant="top"
          src={props.imgPath}
          alt="card-img"
          style={{
            objectFit: imgFit,
            background: imgFit === "contain" ? "#ffffff" : undefined,
          }}
        />
      )}
      <Card.Body>
        <Card.Title>{props.title}</Card.Title>
        <Card.Text style={{ textAlign: "justify" }}>
          {props.description}
        </Card.Text>
        {hasGithub && (
          <Button variant="primary" href={props.ghLink} target="_blank">
            <BsGithub /> &nbsp;
            {primaryLabel}
          </Button>
        )}

        {/* If the component contains Demo link and if it's not a Blog then, it will render the below component  */}

        {!props.isBlog && hasDemo && (
          <Button
            variant="primary"
            href={props.demoLink}
            target="_blank"
            style={{ marginLeft: hasGithub ? "10px" : "0px" }}
          >
            <CgWebsite /> &nbsp;
            {demoLabel}
          </Button>
        )}
      </Card.Body>
    </Card>
  );
}
export default ProjectCards;
